import React from 'react';

import { Box, Grid, Typography } from '@material-ui/core';

import AutoParadoIcon from '../../../../assets/img/assistance/battery_type/vehicle_doesnt_start.svg';
import AutoMovimientoIcon from '../../../../assets/img/assistance/battery_type/vehicle_stopped_moving.svg';
// import AutoMovimientoIcon from '../../../../assets/img/auto_movimiento.png';
// import AutoParadoIcon from '../../../../assets/img/auto_parado.png';
import {
  ASSISTANCE_TYPE_TIRE,
  AssistanceDetails,
} from '../../../../constants/assistance.constant';
import { useAssistanceDataContext } from '../../../../context/assistance/assistance.provider';
import SelectionCards from '../Subcomponents/SelectionCards.component';

const PROBLEMS_GEN = [
  {
    title: 'El vehículo se apagó en movimiento',
    icon: AutoMovimientoIcon,
    value: AssistanceDetails.VEHICLE_STOPPED_WHILE_DRIVING,
  },
  {
    title: 'El vehículo directamente no arranca',
    icon: AutoParadoIcon,
    value: AssistanceDetails.VEHICLE_WONT_START,
  },
];

const PROBLEMS_TIRE = [
  {
    title: 'Si, tengo rueda de auxilio',
    value: AssistanceDetails.SPARE_TIRE,
  },
  {
    title: 'No tengo rueda de auxilio',
    value: AssistanceDetails.NO_SPARE_TIRE,
  },
];

const HowItHappened = () => {
  const { assistance_body } = useAssistanceDataContext();

  return assistance_body.assistance_type === ASSISTANCE_TYPE_TIRE ? (
    <Grid container>
      <Grid item xs={12}>
        <Box my={3}>
          <Typography variant="h6"> ¿Contás con rueda de auxilio? </Typography>
        </Box>
      </Grid>
      <SelectionCards
        relatedField={'assistance_detail'}
        cards={PROBLEMS_TIRE}
      ></SelectionCards>
    </Grid>
  ) : (
    <Grid container>
      <Grid item xs={12}>
        <Box my={3}>
          <Typography variant="h6" color="textPrimary">
            {' '}
            ¿Cómo sucedió?{' '}
          </Typography>
        </Box>
      </Grid>
      <SelectionCards
        relatedField={'assistance_detail'}
        cards={PROBLEMS_GEN}
      ></SelectionCards>
    </Grid>
  );
};

export default HowItHappened;
